import React, { MouseEvent, MouseEventHandler } from "react";

import { useGetLinkComponentAndProps } from "../../../hooks/link";
import { LocationShape } from "../../../types";
import { Icon } from "../../content";
import { Center } from "../../layout";
import { sizeMap, useGetIconButtonStyles } from "../IconButton";
import { IconButtonProps } from "../IconButton/IconButton";

type Props = Omit<IconButtonProps, "onClick"> & {
  to: string | LocationShape;
  onClick?: MouseEventHandler;
  newTab?: boolean;
  replace?: boolean;
};

export default function IconButtonLink({
  iconName,
  onClick,
  size = "large",
  to,
  newTab,
  tone = "primary",
  disabled = false,
  replace,
  blend = false,
  accessibilityLabel
}: Props) {
  const styleProps = useGetIconButtonStyles({
    tone,
    disabled,
    blend,
    size
  });

  const { Component, linkProps } = useGetLinkComponentAndProps({
    to,
    disabled,
    newTab,
    replace
  });

  const { iconSize } = sizeMap[size];

  return (
    <Component
      onClick={(e: MouseEvent) => {
        !disabled && onClick && onClick(e);
      }}
      aria-label={accessibilityLabel}
      disabled={disabled}
      {...styleProps}
      {...linkProps}
    >
      <Center>
        <Icon accessibilityLabel={null} iconName={iconName} size={iconSize} />
      </Center>
    </Component>
  );
}
